module.exports = __webpack_public_path__ + "img/pic_ua_new.c9176db0.png";